import { useEffect, useState } from "react";
import PageLayout from "../../components/PageLayout/PageLayout";
import {
  useAnalyticsEventTracker,
  useAppDispatch,
  useAppSelector,
} from "../../hooks";
import { getUser } from "../../store/reducers/user";
import "./Dashboard.scss";
import DashboardSlider from "./DashboardSlider/DashboardSlider";
import Button from "../../components/Button/Button";
import { useNavigate } from "react-router-dom";
import { formatDate } from "../../hooks";

import { ReactComponent as HandShake } from "./img/hand-shake.svg";
import { ReactComponent as MoneyIcon } from "./img/money.svg";

import {
  balanceSummary,
  visitStats,
  periodStats,
} from "../../store/actions/account";
import {
  getAccountBalance,
  getAccountProfit,
  getReferrals,
  getSeasons,
  getSeasonsInfo,
  getVisitStats,
  getPeriodStats,
} from "../../store/reducers/account";
import { showDrawer } from "../../store/actions/ui";
import { ReactComponent as Hand } from "./img/hand.svg";
import { ReactComponent as Clock } from "./img/clock.svg";
import MobileDetect from "mobile-detect";
//@ts-ignore
import PWAPrompt from "react-ios-pwa-prompt";

const FileTypeDashboardTile = ({
  mainTask,
  periodData,
  targetAssumed,
  usersTargets,
  currentTargetInPercentRounded,
  value,
}: {
  mainTask: boolean;
  periodData: any;
  targetAssumed: any;
  usersTargets: any;
  currentTargetInPercentRounded: any;
  value: any;
}) => {
  return (
    <div className={`main-task file-type ${mainTask ? "active" : ""}`}>
      <div className={`header ${!mainTask ? "empty" : ""}`}>
        <div className="temp-header">
          <h3 className={`temp-title`}>Główne zadanie:</h3>
          {mainTask && (
            <p className="copy">
              Zrealizuj przypisany do Twojego oddziału target wolumenowy
              <strong> w&nbsp;okresie od 1 do 31 października.</strong>
            </p>
          )}
        </div>

        {mainTask ? (
          <>
            <div className="value">
              {/* {visits?.currentPeriod?.payout} zł 25 zł */}
              {value} zł
            </div>
            {/* <p className="disclaimer">
                (za każdą skuteczną rejestrację)* **
                <span>
                  **VEO Arctic Click, VEO Scarlet Click, VEO Green Click, VEO
                  Violet Click
                </span>
              </p> */}

            <div className="temp-activity">
              <p className="copy mobile">
                Zrealizuj przypisany do Twojego oddziału target wolumenowy
                <strong> w&nbsp;okresie od 1 do 31 października.</strong>
              </p>
              <h3 className="temp-title">Nagrody:</h3>
              <ul>
                <li>105% realizacji – 300 zł</li>
                <li>107% realizacji – 500 zł</li>
                <li>110% realizacji – 700 zł</li>
              </ul>
            </div>
          </>
        ) : (
          <div className="alt-desc">
            <p>
              Obecnie nie ma dostępnego głównego zadania w programie, ale nie
              martw się!
            </p>
            <p> Pracujemy nad nową aktywnością, która pojawi się wkrótce.</p>
          </div>
        )}
      </div>

      {mainTask && (
        <div className="earnings-info">
          <div>
            <div className="legend-wrapper">
              <div className="content">
                <div>
                  <div>
                    <div className="item">
                      <HandShake /> Twój target:&nbsp;
                      <strong>{targetAssumed}</strong>
                    </div>
                    <p className="earnings-disclaimer">{`
                           105% – ${usersTargets["target_105"]},
                            107% – ${usersTargets["target_107"]},
                             110% realizacji – ${usersTargets["target_110"]}
                           `}</p>
                  </div>

                  <div>
                    <div className="item">
                      <MoneyIcon />
                      Realizacja:&nbsp;
                      <strong> {currentTargetInPercentRounded}%*</strong>
                    </div>

                    <p className="earnings-disclaimer">
                      *Dane o realizacji są aktualizowane raz w tygodniu{" "}
                      <span>(w&nbsp;poniedziałek)</span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
const VisitTypeDashboardTile = ({
  mainTask,
  periodData,
  value,
}: {
  mainTask: boolean;
  periodData: any;
  value: any;
}) => {
  return (
    <>
      <div className={`main-task ${mainTask ? "active" : ""}`}>
        <div className="header">
          <h2 className="title">Główne zadanie:</h2>
          {/* <div className="temp-header">
                <h3 className="temp-title">Główne zadanie:</h3>
                {mainTask && (
                  <p className="copy">
                    Zrealizuj przypisany do Twojego oddziału target wolumenowy
                    w&nbsp;okresie od 1 do 31 sierpnia.
                  </p>
                )}
              </div> */}

          {mainTask ? (
            <>
              <div className="value">
                {/* {visits?.currentPeriod?.payout} zł */}
                {/* {value} zł */}
                do {value[4]} zł
              </div>
              <br />
              <p className="date">
                {formatDate(periodData?.currentPeriod?.start, {
                  month: "2-digit",
                  day: "2-digit",
                })}{" "}
                -{" "}
                {formatDate(periodData?.currentPeriod?.end, {
                  month: "2-digit",
                  day: "2-digit",
                  year: "2-digit",
                })}
              </p>
              {/* <p className="disclaimer">
                <span>
                  <strong>*Premia od 2 SKU. </strong>2 warianty – 20 zł • 3
                  warianty – 35 zł • 4 warianty – 60 zł
                </span>
              </p> */}

              <p className="main-disclaimer">
                <span>
                  <strong>*Premia od 2 SKU. </strong> 2 warianty – 20 zł • 3
                  warianty – 35 zł • 4 warianty – 60 zł
                </span>
              </p>
              {/* <div className="temp-activity">
                  <p className="copy mobile">
                    Zrealizuj przypisany do Twojego oddziału target wolumenowy
                    w&nbsp;okresie od 1 do 31 sierpnia.
                  </p>
                  <h3 className="temp-title">Nagrody:</h3>
                  <ul>
                    <li>105% realizacji – 300 zł</li>
                    <li>107% realizacji – 500 zł</li>
                    <li>110% realizacji – 700 zł</li>
                  </ul>
                </div> */}
            </>
          ) : (
            <div className="alt-desc">
              <p>
                Obecnie nie ma dostępnego głównego zadania w programie, ale nie
                martw się!
              </p>
              <p> Pracujemy nad nową aktywnością, która pojawi się wkrótce.</p>
            </div>
          )}
        </div>

        {mainTask && (
          <div className="earnings-info">
            <div>
              <div className="legend-wrapper">
                <div className="content">
                  <div>
                    <div className="item">
                      <HandShake /> Zarejestrowane wizyty:&nbsp;
                      <strong>{periodData?.currentPeriod?.count}</strong>
                    </div>
                    {/* <div>
                          <div className="item">
                            <HandShake /> Twój target:&nbsp;
                            <strong>{targetAssumed}</strong>
                          </div>
                          <p className="earnings-disclaimer">{`
                           105% – ${usersTargets["target_105"]},
                            107% – ${usersTargets["target_107"]},
                             110% realizacji – ${usersTargets["target_110"]}
                           `}</p>
                        </div> */}
                    <div className="item">
                      <MoneyIcon />
                      Nagrody:&nbsp;
                      <strong>{periodData?.currentPeriod?.payout} zł*</strong>
                    </div>
                    <div>
                      {/* <div className="item">
                            <MoneyIcon />
                            Realizacja:&nbsp;
                            <strong> {currentTargetInPercentRounded}%*</strong>
                          </div> */}

                      {/* <p className="earnings-disclaimer">
                            *Dane o realizacji są aktualizowane dwa razy w
                            tygodniu{" "}
                            <span>(w&nbsp;poniedziałki i&nbsp;czwartki)</span>
                          </p> */}
                    </div>
                    <p className="earnings-disclaimer">
                      *Wyświetlona kwota jest przybliżona. Czekamy na jej
                      potwierdzenie
                    </p>
                  </div>
                  <Button path="/rejestracja-wizyty">Zarejestruj wizytę</Button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

function Dashboard() {
  const navigate = useNavigate();
  const user = useAppSelector(getUser);
  const balance = useAppSelector(getAccountBalance);
  // const visits = useAppSelector(getVisitStats);
  const periodData = useAppSelector(getPeriodStats);

  const profit = useAppSelector(getAccountProfit);
  const dispatch = useAppDispatch();
  // const gaEventTracker = useAnalyticsEventTracker("Dashboard Event");
  const timeToShowPopup = localStorage.getItem("POP_MODAL_TIME");
  const [device, setDevice] = useState<any>({});
  const [iOSPrompt, setiOSPrompt] = useState(false);
  const [missingUserData, setMissingUserData] = useState(false);

  const mainTask = periodData?.currentPeriod?.isActive;
  const periodIsFileType = periodData?.currentPeriod?.periodFileType;
  const usersTargets = user?.target?.assumedArray ?? [];

  const targetAssumed = usersTargets["target_100"] ?? 0;
  const targetAchieved = user?.target?.achieved ?? 0;

  const currentTargetInPercent =
    targetAssumed > 0 ? (targetAchieved / targetAssumed) * 100 : 0;
  const currentTargetInPercentRounded =
    Math.round(currentTargetInPercent * 100) / 100;

  // console.log(targetAssumed, "targetAssumed");
  // console.log(targetAchieved, "targetAchieved");

  // console.log("visitStats", visits);

  const handleShowPopup = (modalsArray: any) => {
    if (modalsArray?.length > 0) {
      const date = new Date();
      const time = date.getTime();
      const weekInHours = 24 * 7;
      const serializeTime = timeToShowPopup ? JSON.parse(timeToShowPopup) : 0;

      if (serializeTime < time) {
        const diff = date.setTime(
          date.getTime() + weekInHours * 60 * 60 * 1000,
        );
        window.localStorage.setItem("POP_MODAL_TIME", JSON.stringify(diff));
        dispatch(showDrawer(modalsArray[0]));
      }
    }
  };
  useEffect(() => {
    handleShowPopup(user?.modals);
  }, [user?.modals]);

  useEffect(() => {
    // dispatch(visitStats());
    dispatch(balanceSummary());
    dispatch(periodStats());

    checkDevice();
  }, []);

  useEffect(() => {
    if (user?.firstName) {
      if (
        user?.dob != null &&
        user?.streetAddress != null &&
        user?.postalCode != null &&
        user?.cityName != null &&
        user?.taxOfficeName != null &&
        user?.iban != null
      ) {
        setMissingUserData(false);
      } else {
        setMissingUserData(true);
      }
    }
    if (user?.firstName && !user?.consent042025) {
      navigate("/zgoda/consent042025");
    }
  }, [user?.dob]);

  const getPWADisplayMode = () => {
    const isStandalone = window.matchMedia(
      "(display-mode: standalone)",
    ).matches;
    if (document.referrer.startsWith("android-app://")) {
      return "twa";
      //@ts-ignore
    } else if (navigator.standalone || isStandalone) {
      return "standalone";
    }
    return "browser";
  };

  const checkDevice = () => {
    const md = new MobileDetect(window.navigator.userAgent);
    const dev = {
      isMobile: md.mobile() ? true : false,
      isIos: md.is("iOS") ? true : false,
      isAndroid: md.is("AndroidOS") || md.is("Android") ? true : false,
      isPWA: getPWADisplayMode() === "standalone" ? true : false,
      //@ts-ignore
      installable: window.deferredPrompt ? true : false,
    };
    setDevice(dev);
  };

  const installPwa = async () => {
    //@ts-ignore
    window.deferredPrompt?.prompt();
    //eslint-disable-next-line
    //@ts-ignore
    const { outcome } = await window.deferredPrompt.userChoice;
    //@ts-ignore
    window.deferredPrompt = null;
  };

  const showPrompt = () => {
    setiOSPrompt(true);
  };

  // const FileTypeDashboardTile = ({ mainTask }: { mainTask: boolean }) => {
  //   return (
  //     <div className={`main-task file-type ${mainTask ? "active" : ""}`}>
  //       <div className={`header ${!mainTask ? "empty" : ""}`}>
  //         <div className="temp-header">
  //           <h3 className={`temp-title`}>Główne zadanie:</h3>
  //           {mainTask && (
  //             <p className="copy">
  //               Zrealizuj przypisany do Twojego oddziału target wolumenowy
  //               w&nbsp;okresie od 1 do 31 sierpnia.
  //             </p>
  //           )}
  //         </div>

  //         {mainTask ? (
  //           <>
  //             <div className="value">
  //               {/* {visits?.currentPeriod?.payout} zł 25 zł */}
  //             </div>
  //             {/* <p className="disclaimer">
  //               (za każdą skuteczną rejestrację)* **
  //               <span>
  //                 **VEO Arctic Click, VEO Scarlet Click, VEO Green Click, VEO
  //                 Violet Click
  //               </span>
  //             </p> */}

  //             <div className="temp-activity">
  //               <p className="copy mobile">
  //                 Zrealizuj przypisany do Twojego oddziału target wolumenowy
  //                 w&nbsp;okresie od 1 do 31 sierpnia.
  //               </p>
  //               <h3 className="temp-title">Nagrody:</h3>
  //               <ul>
  //                 <li>105% realizacji – 300 zł</li>
  //                 <li>107% realizacji – 500 zł</li>
  //                 <li>110% realizacji – 700 zł</li>
  //               </ul>
  //             </div>
  //           </>
  //         ) : (
  //           <div className="alt-desc">
  //             <p>
  //               Obecnie nie ma dostępnego głównego zadania w programie, ale nie
  //               martw się!
  //             </p>
  //             <p> Pracujemy nad nową aktywnością, która pojawi się wkrótce.</p>
  //           </div>
  //         )}
  //       </div>

  //       {mainTask && (
  //         <div className="earnings-info">
  //           <div>
  //             <div className="legend-wrapper">
  //               <div className="content">
  //                 <div>
  //                   <div>
  //                     <div className="item">
  //                       <HandShake /> Twój target:&nbsp;
  //                       <strong>{targetAssumed}</strong>
  //                     </div>
  //                     <p className="earnings-disclaimer">{`
  //                          105% – ${usersTargets["target_105"]},
  //                           107% – ${usersTargets["target_107"]},
  //                            110% realizacji – ${usersTargets["target_110"]}
  //                          `}</p>
  //                   </div>

  //                   <div>
  //                     <div className="item">
  //                       <MoneyIcon />
  //                       Realizacja:&nbsp;
  //                       <strong> {currentTargetInPercentRounded}%*</strong>
  //                     </div>

  //                     <p className="earnings-disclaimer">
  //                       *Dane o realizacji są aktualizowane dwa razy w tygodniu{" "}
  //                       <span>(w&nbsp;poniedziałki i&nbsp;czwartki)</span>
  //                     </p>
  //                   </div>
  //                 </div>
  //               </div>
  //             </div>
  //           </div>
  //         </div>
  //       )}
  //     </div>
  //   );
  // };
  // const VisitTypeDashboardTile = ({ mainTask }: { mainTask: boolean }) => {
  //   return (
  //     <>
  //       <div className={`main-task ${mainTask ? "active" : ""}`}>
  //         <div className="header">
  //           <h2 className="title">Główne zadanie:</h2>
  //           {/* <div className="temp-header">
  //               <h3 className="temp-title">Główne zadanie:</h3>
  //               {mainTask && (
  //                 <p className="copy">
  //                   Zrealizuj przypisany do Twojego oddziału target wolumenowy
  //                   w&nbsp;okresie od 1 do 31 sierpnia.
  //                 </p>
  //               )}
  //             </div> */}

  //           {mainTask ? (
  //             <>
  //               <div className="value">
  //                 {/* {visits?.currentPeriod?.payout} zł */}
  //                 25 zł
  //               </div>
  //               <p className="disclaimer">
  //                 (za każdą skuteczną rejestrację)* **
  //                 <span>
  //                   **VEO Arctic Click, VEO Scarlet Click, VEO Green Click, VEO
  //                   Violet Click
  //                 </span>
  //               </p>
  //               <p className="date">
  //                 {formatDate(periodData?.currentPeriod?.start, {
  //                   month: "2-digit",
  //                   day: "2-digit",
  //                 })}{" "}
  //                 -{" "}
  //                 {formatDate(periodData?.currentPeriod?.end, {
  //                   month: "2-digit",
  //                   day: "2-digit",
  //                   year: "2-digit",
  //                 })}
  //               </p>
  //               <p className="main-disclaimer">
  //                 *za wyjątkiem punktów znajdujących sie na stopliście
  //               </p>
  //               {/* <div className="temp-activity">
  //                 <p className="copy mobile">
  //                   Zrealizuj przypisany do Twojego oddziału target wolumenowy
  //                   w&nbsp;okresie od 1 do 31 sierpnia.
  //                 </p>
  //                 <h3 className="temp-title">Nagrody:</h3>
  //                 <ul>
  //                   <li>105% realizacji – 300 zł</li>
  //                   <li>107% realizacji – 500 zł</li>
  //                   <li>110% realizacji – 700 zł</li>
  //                 </ul>
  //               </div> */}
  //             </>
  //           ) : (
  //             <div className="alt-desc">
  //               <p>
  //                 Obecnie nie ma dostępnego głównego zadania w programie, ale
  //                 nie martw się!
  //               </p>
  //               <p>
  //                 {" "}
  //                 Pracujemy nad nową aktywnością, która pojawi się wkrótce.
  //               </p>
  //             </div>
  //           )}
  //         </div>

  //         {mainTask && (
  //           <div className="earnings-info">
  //             <div>
  //               <div className="legend-wrapper">
  //                 <div className="content">
  //                   <div>
  //                     <div className="item">
  //                       <HandShake /> Zarejestrowane wizyty:&nbsp;
  //                       <strong>{periodData?.currentPeriod?.count}</strong>
  //                     </div>
  //                     {/* <div>
  //                         <div className="item">
  //                           <HandShake /> Twój target:&nbsp;
  //                           <strong>{targetAssumed}</strong>
  //                         </div>
  //                         <p className="earnings-disclaimer">{`
  //                          105% – ${usersTargets["target_105"]},
  //                           107% – ${usersTargets["target_107"]},
  //                            110% realizacji – ${usersTargets["target_110"]}
  //                          `}</p>
  //                       </div> */}
  //                     <div className="item">
  //                       <MoneyIcon />
  //                       Nagrody:&nbsp;
  //                       <strong>{periodData?.currentPeriod?.payout} zł*</strong>
  //                     </div>
  //                     <div>
  //                       {/* <div className="item">
  //                           <MoneyIcon />
  //                           Realizacja:&nbsp;
  //                           <strong> {currentTargetInPercentRounded}%*</strong>
  //                         </div> */}

  //                       {/* <p className="earnings-disclaimer">
  //                           *Dane o realizacji są aktualizowane dwa razy w
  //                           tygodniu{" "}
  //                           <span>(w&nbsp;poniedziałki i&nbsp;czwartki)</span>
  //                         </p> */}
  //                     </div>
  //                     <p className="earnings-disclaimer">
  //                       *Wyświetlona kwota jest przybliżona. Czekamy na jej
  //                       potwierdzenie
  //                     </p>
  //                   </div>
  //                   <Button path="/rejestracja-wizyty">
  //                     Zarejestruj wizytę
  //                   </Button>
  //                 </div>
  //               </div>
  //             </div>
  //           </div>
  //         )}
  //       </div>
  //     </>
  //   );
  // };

  return (
    <PageLayout>
      <div className="page Dashboard">
        <div className="user-info">
          <div className="hello">
            <div className="hello-name">
              <div>Witaj</div>
              <div className="user-name">{user?.firstName}</div>
              <div>Twój numer BAT Partnera: </div>
              <div className="user-name">{user?.referralCode}</div>
              <div className="bp-number">
                <hr />
                <div>Należysz&nbsp;do: </div>
                <div className="user-wholesaler">
                  {user?.wholesaler?.ident}
                  <br />
                  <span>{user?.wholesalerBranch?.ident}</span>
                </div>
                <hr />
              </div>
            </div>

            <div className="account-balance">
              <div>Twoje dostępne saldo:</div>
              <span className="value">
                <MoneyIcon />
                {balance} zł
              </span>
            </div>
          </div>
          {periodIsFileType ? (
            <FileTypeDashboardTile
              mainTask={mainTask}
              periodData={periodData}
              targetAssumed={targetAssumed}
              usersTargets={usersTargets}
              currentTargetInPercentRounded={currentTargetInPercentRounded}
              value={periodData?.currentPeriod?.value}
            />
          ) : (
            <VisitTypeDashboardTile
              periodData={periodData}
              mainTask={mainTask}
              value={periodData?.currentPeriod?.value}
            />
          )}
        </div>

        <div className="dash-news">
          <h2>Co nowego?</h2>
          <DashboardSlider />
        </div>
        {device.isMobile &&
          (device.installable || device.isIos) &&
          !device.isPWA && (
            <div className="dash-shortcut dropshadow-box">
              <div className="dash-shortcut-content">
                <h2>
                  Korzystaj z BAT Partners HURT <br />w formie aplikacji.
                </h2>
                <ul>
                  <li>
                    <Hand />
                    <span>Łatwy dostęp</span>
                  </li>
                  <li>
                    <Clock />
                    <span>Sprawne korzystanie</span>
                  </li>
                </ul>
              </div>
              <div className="shortcut-box">
                <p>
                  Zamień stronę internetową <br /> na aplikację webową!
                </p>
                <Button
                  onClick={() => {
                    if (device.isIos) {
                      showPrompt();
                    } else if (device.isAndroid) {
                      installPwa();
                    }
                  }}
                >
                  Dodaj skrót
                </Button>
              </div>
            </div>
          )}
      </div>
      {iOSPrompt && (
        <PWAPrompt
          promptOnVisit={0}
          timesToShow={999}
          copyClosePrompt="Zamknij"
          permanentlyHideOnDismiss={false}
          onClose={() => {
            setTimeout(() => {
              setiOSPrompt(false);
            }, 500);
          }}
          copyTitle="Dodaj do ekranu początkowego"
          copyBody="Wrzuć ikonę na pulpit i odpalaj BAT Partners HURT jednym ruchem - szybciej niż kiedykolwiek."
          copyShareButtonLabel="1) Naciśnij przycisk udostępniania widoczny na środku dolnego paska nawigacyjnego."
          copyAddHomeButtonLabel="2) Naciśnij „Do ekranu początkowego”"
        />
      )}
    </PageLayout>
  );
}

export default Dashboard;
